import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleAction } from '../schedule.action';

type IDependencies = IClientApiDependencySegment;

export const removeScheduleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteSchedule(params).pipe(
      mergeMap(() => {
        return [
          ScheduleAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          ScheduleAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
